/* global _ */
import { createStore, compose, applyMiddleware } from 'redux';
import createLogger from 'redux-logger';
import thunk from 'redux-thunk';

import ClientStorage from './util/ClientStorage';
import errorHandler from './middleware/errorHandler';
import reducer from './reducers/';

/*
  Configure the redux store instance and add middlewares.
*/
const configureStore = () => {
  const persistedState = ClientStorage.getPersistedState();
  const middlewares = [thunk, errorHandler];

  // Use logger in development mode.
  if (process.env.NODE_ENV === 'dev') {
    middlewares.push(createLogger());
  }

  const store = createStore(
    reducer,
    persistedState && persistedState.booking.savedState ? persistedState : undefined,
    compose(
      applyMiddleware(...middlewares),
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  );

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store.js